import { Injectable } from '@angular/core';
import { UserOnSession } from '@core/auth/auth.type';

@Injectable({ providedIn: 'root' })
export class PermissionActions {
    private actionName = {
        preview: 'preview',
        create: 'create',
        update: 'update',
        delete: 'delete',
    };

    private listAction = {
        [this.actionName.preview]: true,
        [this.actionName.create]: false,
        [this.actionName.update]: false,
        [this.actionName.delete]: false,
    };

    setPermission(userOnSession: UserOnSession | null) {
        if (userOnSession && userOnSession.is_hyperadmin) {
            this.listAction[this.actionName.preview] = true;
            this.listAction[this.actionName.create] = true;
            this.listAction[this.actionName.update] = true;
            this.listAction[this.actionName.delete] = true;
        }
    }

    getActions() {
        return this.listAction;
    }
}
